// extracted by mini-css-extract-plugin
export default {"uploadWrapper":"fileUpload_uploadWrapper__56rPz","xlWrapper":"fileUpload_xlWrapper__MFjIU","notificationPlacement":"fileUpload_notificationPlacement__GTs-F"};